import { required } from 'vuelidate/lib/validators'

const formData = {
  'name': {
    size: 7,
    type: 'text',
    name: 'product',
    label: '',
    placeholder: 'Nome do medicamento',
    value: null
  },
  'label': {
    size: 3,
    type: 'text',
    name: 'description',
    label: '',
    placeholder: 'Concentração/unidade',
    value: null
  },
  'activePrinciples': {
    type: 'array',
    name: 'activePrinciple',
    label: '',
    placeholder: 'Princípio ativo',
    value: null
  },
  'internalUse': {
    size: 12,
    type: 'switch',
    name: 'isRestrictedUse',
    label: 'Uso restrito',
    value: false,
    checkboxes: [
      {
        value: 'true',
        label: 'Uso restrito'
      }
    ]
  },
  'specialControl': {
    size: 12,
    type: 'switch',
    name: 'isSpecialPrescription',
    label: 'Uso controlado',
    value: false,
    checkboxes: [
      {
        value: 'true',
        label: 'Uso controlado'
      }
    ]
  }
}

let requiredFields = ['name', 'label', 'activePrinciples']
const validations = {}
for (let requiredField of requiredFields) {
  validations[requiredField] = {}
  validations[requiredField].value = {}
  validations[requiredField].value.required = required
}

export {formData, validations}
